var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooth03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.47 160.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m87.44,79.16c-.92,4.78.46,9.72,3.04,14.46,2.57,4.75,10.06,14.13,8.65,33.67-1.41,19.54-3.29,29.37-17.33,30.04-14.04.67-23.64-3.74-25.98-3.63-2.34.11-4.57,2.65-11.59,2.99-7.02.34-32.42,8.85-37.92-7.93C.81,131.99.23,119.85,2.22,112.45l1.03-7.5,2.34-4.69c2.34-4.69,4.69-16.4,0-35.15S11.49,9.29,11.49,9.29c0,0,6.67-7.62,11.36-7.85,0,0,6.91-2.76,5.15,9.49s11.35,43.75,16.26,48.38c4.91,4.63,9.48,1.98,11.47-5.42,0,0,15.48-30.97,15.48-35.66s9.37-23.43,14.06-9.37,6.68,46.85,2.17,70.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m23.12,137.5s19.35,3.06,29.06-8.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m50.39,145.49s-.38-7.95,7.28-8.32c7.66-.37,15.45,1.92,20.56,1.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m19.5,88.52s34.93-12.65,63.99-.4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m44.26,59.31c4.66,4.4,9.01,2.23,11.14-4.33-4.88-11.25-8.6-36.34-12.31-43.77-4.69-9.37-7.03,0-7.03,0l-6.84,12.3c3.25,14.18,11.4,32.37,15.04,35.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooth03);
export default __webpack_public_path__ + "static/media/tooth-03.3f3559dee47fc3f33203abb13e19c01f.svg";
export { ForwardRef as ReactComponent };